import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, adminOnly = false }) {
  const { user, isAdmin, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center retro-gradient-bg">
        <div className="retro-card px-8 py-6 flex items-center gap-3" data-testid="auth-loading">
          <Loader2 className="animate-spin" />
          <span className="font-pixel text-xs">LOADING...</span>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (adminOnly && !isAdmin) {
    return (
      <div className="min-h-screen flex items-center justify-center retro-gradient-bg p-6">
        <div className="retro-card p-10 max-w-md text-center" data-testid="access-denied">
          <h2 className="font-heading text-3xl mb-3">Access Denied</h2>
          <p className="font-body text-sm">You are not authorized to access this admin panel.</p>
        </div>
      </div>
    );
  }

  return children;
}
